// src/App.jsx
import React, { useState, useEffect } from "react";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import LoginPage              from "./views/auth/LoginPage";
import Sidebar                from "./components/layout/Sidebar";
import Topbar                 from "./components/layout/Topbar";
import Dashboard              from "./views/dashboard/Dashboard";
import BoletoPublico          from "./views/public/BoletoPublico";
import ResetSenhaPage        from "./views/auth/ResetSenhaPage";
import FechamentosList        from "./views/fechamentos/FechamentosList";
import DashboardFinanceiro    from "./views/dashboard/DashboardFinanceiro";
import CondominiosList        from "./views/condominios/CondominiosList";
import CondominosList         from "./views/condominos/CondominosList";
import UnidadesList           from "./views/unidades/UnidadesList";
import FuncionariosList       from "./views/funcionarios/FuncionariosList";
import FornecedoresList       from "./views/fornecedores/FornecedoresList";
import ContasContabeisList    from "./views/contasContabeis/ContasContabeisList";
import ContasBancariasList    from "./views/contasBancarias/ContasBancariasList";
import ContasPagarList        from "./views/contasPagar/ContasPagarList";
import PagamentosFila         from "./views/pagamentos/PagamentosFila";
import ContasReceberList      from "./views/contasReceber/ContasReceberList";
import DespesasRecorrentesList from "./views/despesasRecorrentes/DespesasRecorrentesList";
import AreasComumList         from "./views/areasComuns/AreasComumList";
import ReservasList           from "./views/reservas/ReservasList";
import OcorrenciasList        from "./views/ocorrencias/OcorrenciasList";
import ComunicadosList        from "./views/comunicados/ComunicadosList";
import CobrancasList          from "./views/cobrancas/CobrancasList";
import BoletosList            from "./views/boletos/BoletosList";
import RenegociacoesList      from "./views/renegociacoes/RenegociacoesList";
import CadastroJobs            from "./views/sistema/CadastroJobs";
import AuditLogs               from "./views/audit/AuditLogs";
import RetornoCNAB              from "./views/boletos/RetornoCNAB";
import ControlIdView           from "./views/controlId/ControlIdView";
import RelatoriosList         from "./views/relatorios/RelatoriosList";
import ConfiguracoesList      from "./views/configuracoes/ConfiguracoesList";
import UsuariosList           from "./views/usuarios/UsuariosList";
import ConsumoList            from "./views/consumo/ConsumoList";
import EstoqueView            from "./views/estoque/EstoqueView";
import PedidosList            from "./views/pedidos/PedidosList";
import ComprasView            from "./views/compras/ComprasView";
import CotacaoList            from "./views/cotacao/CotacaoList";
import CotacaoFornecedorPublic from "./views/public/CotacaoFornecedorPublic";
import InventarioView         from "./views/inventario/InventarioView";
import ChecklistsView         from "./views/checklist/ChecklistsView";
import PortalChecklist        from "./views/checklist/PortalChecklist";
import TrocarSenhaObrigatoria from "./components/TrocarSenhaObrigatoria";
import OnboardingWizard        from "./components/onboarding/OnboardingWizard";
import AssembleiasList         from "./views/assembleias/AssembleiasList";
import VotacaoOnline           from "./views/assembleias/VotacaoOnline";
import ClientesList            from "./views/saas/ClientesList";
import SaasDashboard           from "./views/saas/SaasDashboard";
import PortalCondomino         from "./views/portal/PortalCondomino";
import ModuloBloqueado         from "./components/ui/ModuloBloqueado";
import PortalPortaria          from "./views/portaria/PortalPortaria";
import PortariaDashboard       from "./views/portaria/PortariaDashboard";
import PlanosList              from "./views/saas/PlanosList";
import PrestacaoContasList     from "./views/prestacaoContas/PrestacaoContasList";
import WhatsappConfig         from "./views/whatsapp/WhatsappConfig";
import "./styles/global.css";

const BREADCRUMBS = {
  dashboard:               ["Dashboard"],
  "dashboard-financeiro":  ["Dashboard Financeiro"],
  "fechamento-mensal":     ["Fechamento Mensal"],
  condominios:         ["Cadastros",    "Condomínios"],
  condominos:          ["Cadastros",    "Condôminos"],
  unidades:            ["Cadastros",    "Unidades"],
  funcionarios:        ["Cadastros",    "Funcionários"],
  fornecedores:        ["Cadastros",    "Fornecedores"],
  contascontabeis:     ["Financeiro",   "Plano de Contas"],
  contasbancarias:     ["Financeiro",   "Contas Bancárias"],
  contaspagar:         ["Financeiro",   "Contas a Pagar"],
  contasreceber:       ["Financeiro",   "Contas a Receber"],
  despesasrecorrentes: ["Financeiro",   "Desp. Recorrentes"],
  cobrancas:           ["Financeiro",   "Cobranças"],
  boletos:             ["Financeiro",   "Controle Boletos"],
  renegociacoes:       ["Financeiro",   "Renegociação"],
  relatorios:          ["Financeiro",   "Relatórios"],

  consumo:             ["Financeiro",   "Água e Gás"],
  estoque:             ["Controle de Estoque", "Estoque"],
  pedidos:             ["Controle de Estoque", "Pedidos"],
  compras:             ["Controle de Estoque", "Compras"],
  cotacao:             ["Controle de Estoque", "Cotação"],
  inventario:          ["Controle de Estoque", "Inventário"],
  checklists:          ["Operacional", "Checklists"],
  assembleias:         ["Comunicação",  "Assembleias"],
    whatsapp:            ["Sistema",      "WhatsApp"],
  areascomuns:         ["Operacional",  "Áreas Comuns"],
  reservas:            ["Operacional",  "Reservas"],
  ocorrencias:         ["Comunicação",  "Ocorrências"],
  comunicados:         ["Comunicação",  "Comunicados"],
  usuarios:            ["Sistema",      "Usuários"],
  relatorios:          ["Financeiro",   "Relatórios"],
  consumo:             ["Financeiro",   "Água e Gás"],
  assembleias:         ["Comunicação",  "Assembleias"],
    whatsapp:            ["Sistema",      "WhatsApp"],
  consumo:             ["Financeiro",   "Água e Gás"],
  assembleias:         ["Comunicação",  "Assembleias"],
  prestacao:           ["Financeiro",   "Prestação de Contas"],
  "cadastro-jobs":     ["Sistema",      "Cadastro de Jobs"],
  audit:               ["Sistema",      "Logs de Auditoria"],
  retorno_cnab:        ["Financeiro",   "Retorno CNAB"],
  controlid:           ["Sistema",      "ControlID"],
  whatsapp:            ["Sistema",      "WhatsApp"],
  config:              ["Sistema",      "Configurações"],
  "portaria-dashboard": ["Portaria",      "Dashboard"],
  "saas-dashboard":    ["Admin SaaS",   "Dashboard"],
  portaria:            ["Portaria",      "Dashboard"],
  "portaria-ocorrencias":["Portaria",    "Ocorrências"],
  "saas-clientes":     ["Admin SaaS",   "Clientes"],
  "saas-planos":       ["Admin SaaS",   "Planos"],
};

const KNOWN = Object.keys(BREADCRUMBS);

const EmBreve = ({label,icon}) => (
  <div style={{textAlign:"center",padding:"80px 0",color:"var(--gray-400)"}}>
    <i className={`bi ${icon}`} style={{fontSize:48,display:"block",marginBottom:12}}/>
    <p style={{fontSize:16,fontWeight:500}}>{label}</p>
  </div>
);

// ── App interno (dentro do AuthProvider) ──────────────────────────────────
function AppInner() {
  const { usuario, carregando, condominioAtivo, trocarCondominio, logout, isAdmin, isSuperAdmin, temModulo } = useAuth();
  const [collapsed,  setCollapsed]  = useState(false);
  const [showWizard, setShowWizard] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeId,   setActiveId]   = useState("dashboard");
  const [badges,     setBadges]     = useState({}); // { reservas: N, ... }

  // Show onboarding wizard for new tenant Admin clients on first login
  const [onboardStatus, setOnboardStatus] = useState(null);
  React.useEffect(() => {
    if (!usuario || usuario.perfil !== "Admin" || !usuario.idCliente || isSuperAdmin) return;
    const doneKey = `onboarding_done_${usuario.idCliente}`;
    const timer = setTimeout(() => {
      import("./services/authService").then(m =>
        m.default.onboardingStatus().then(r => {
          setOnboardStatus(r);
          // Abre wizard automaticamente apenas se realmente precisa (setup incompleto e usuário ainda não fechou o wizard)
          if (r?.needed && localStorage.getItem(doneKey) !== "done") {
            setShowWizard(true);
          }
        }).catch(()=>{})
      );
    }, 800);
    return () => clearTimeout(timer);
  }, [usuario?.id, isSuperAdmin]);

  // Se ainda está verificando sessão, mostra loading
  if (carregando) {
    return (
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",
        justifyContent:"center",background:"var(--bg-page)"}}>
        <div style={{textAlign:"center"}}>
          <span className="spinner-border text-primary" style={{width:40,height:40}}/>
          <p style={{marginTop:12,color:"var(--gray-400)"}}>Carregando...</p>
        </div>
      </div>
    );
  }

  // Não autenticado → tela de login
  // Rota pública: votação online de assembleia (/votar?token=xxx)
  const _path = window.location.pathname;
  const _search = window.location.search;
  if (_path === "/votar" || _path.endsWith("/votar")) {
    return <VotacaoOnline/>;
  }
  if (_search.includes("token=") && (_path.includes("votar") || _search.includes("votar"))) {
    return <VotacaoOnline/>;
  }

  if (!usuario) return <LoginPage/>;

  // Condômino: redireciona para portal simplificado
  if (usuario?.primeiroAcesso) {
    return <TrocarSenhaObrigatoria
      usuario={usuario}
      onTrocada={() => {
        const updated = {...usuario, primeiroAcesso: false};
        localStorage.setItem("usuario", JSON.stringify(updated));
        window.location.reload();
      }}
    />;
  }

  if (usuario.perfil === "Condomino") {
    // Verifica se o plano inclui portal do condômino
    if (temModulo && !temModulo("portalCondomino")) {
      return <ModuloBloqueado modulo="Portal do Condômino" onLogout={logout}/>;
    }
    return <PortalCondomino onLogout={logout}/>;
  }

  // Porteiro / Portaria: portal operacional da portaria
  if (["Porteiro", "Portaria"].includes(usuario.perfil)) {
    // Verifica se o plano inclui portaria
    if (temModulo && !temModulo("portaria-dashboard")) {
      return <ModuloBloqueado modulo="Portaria Digital" onLogout={logout}/>;
    }
    return <PortalPortaria onLogout={logout}/>;
  }

  // Operacional: portal checklist em campo (exige módulos do plano)
  if (usuario.perfil === "Operacional") {
    const faltaGestao = temModulo && !temModulo("checklists");
    const faltaPortal = temModulo && !temModulo("portalChecklist");
    if (faltaGestao || faltaPortal) {
      const faltando = [
        faltaGestao ? "Checklists (gestão)" : null,
        faltaPortal ? "Portal Checklist" : null,
      ].filter(Boolean).join(" e ");
      return (
        <ModuloBloqueado
          modulo="Checklists"
          detalhe={`Módulo(s) ausente(s) no plano: ${faltando}. Peça ao administrador para habilitar checklists e portalChecklist em Admin SaaS → Planos.`}
          onLogout={logout}
        />
      );
    }
    return <PortalChecklist onLogout={logout}/>;
  }

  const handleToggle = () => {
    if (window.innerWidth <= 991) setMobileOpen(p=>!p);
    else setCollapsed(p=>!p);
  };

  const handleNavigate = (id) => {
    // Block navigation if module not in plan
    if (!isSuperAdmin && temModulo && !temModulo(id)) return;
    setActiveId(id);
    if (window.innerWidth <= 991) setMobileOpen(false);
  };

  return (
    <div className="app-wrapper">
      {showWizard && (
        <OnboardingWizard
          onClose={()=>setShowWizard(false)}
          onNavigate={(id)=>{ setShowWizard(false); setActiveId(id); }}
        />
      )}
      {mobileOpen && <div className="sidebar-overlay" onClick={()=>setMobileOpen(false)}/>}
      <Sidebar collapsed={collapsed} mobileOpen={mobileOpen}
        onNavigate={handleNavigate} activeId={activeId} usuario={usuario}
        badges={badges}/>
      <div className={`main-content ${collapsed?"sidebar-collapsed":""}`}>
        <Topbar
          collapsed={collapsed} onToggle={handleToggle}
          breadcrumbs={BREADCRUMBS[activeId]||["Página"]}
          idCondominio={condominioAtivo?.id||null}
          usuario={usuario}
          condominioAtivo={condominioAtivo}
          onTrocarCondominio={trocarCondominio}
          onLogout={logout}
          onNavigate={handleNavigate}
          onBadgesChange={(b)=>setBadges(prev=>({...prev,...b}))}
          onAbrirOnboarding={()=>setShowWizard(true)}/>
        {/* Grace Period Warning Banner */}
        {usuario?.clienteStatus === "GracePeriod" && (
          <div style={{background:"var(--bg-warning-soft)",borderBottom:"2px solid #FDE68A",
            padding:"8px 20px",display:"flex",alignItems:"center",fontSize:13}}>
            <i className="bi bi-exclamation-triangle-fill" style={{fontSize:16,color:"#854D0E",marginRight:8}}/>
            <span style={{color:"#854D0E"}}>
              <strong>Atenção:</strong> Sua licença está vencida. O acesso será bloqueado em breve.
              Entre em contato com o suporte para regularizar o pagamento.
            </span>
          </div>
        )}
        {/* Banner de progresso do onboarding (Admin com setup incompleto) */}
        {!showWizard && !onboardStatus?._dismissed && usuario?.perfil === "Admin" && !isSuperAdmin && onboardStatus &&
          onboardStatus.pctConcluido > 0 && onboardStatus.pctConcluido < 100 && (
          <div style={{background:"linear-gradient(90deg,#EFF6FF,#F0FDF4)",
            borderBottom:"1px solid #BFDBFE",padding:"8px 20px",
            display:"flex",alignItems:"center",gap:14,fontSize:13}}>
            <i className="bi bi-magic" style={{fontSize:18,color:"#1D4ED8"}}/>
            <div style={{flex:1}}>
              <div style={{color:"#1E40AF",fontWeight:600,fontSize:12.5}}>
                Configuração inicial: {onboardStatus.concluidos}/{onboardStatus.total} concluídos ({onboardStatus.pctConcluido}%)
              </div>
              <div style={{height:4,background:"var(--bg-highlight)",borderRadius:2,marginTop:4,overflow:"hidden"}}>
                <div style={{height:"100%",width:`${onboardStatus.pctConcluido}%`,
                  background:"linear-gradient(90deg,#3B82F6,#10B981)",transition:"width .3s"}}/>
              </div>
            </div>
            <button className="btn btn-sm btn-primary" style={{fontSize:12,padding:"3px 12px"}}
              onClick={()=>setShowWizard(true)}>
              Continuar Setup
            </button>
            <button onClick={()=>setOnboardStatus(p=>({...p,_dismissed:true}))}
              style={{background:"none",border:"none",color:"var(--gray-400)",cursor:"pointer",fontSize:18,lineHeight:1}}
              title="Fechar">×</button>
          </div>
        )}
        <main className="page-body">
          {activeId==="dashboard"           && <Dashboard onNavigate={handleNavigate}/>}
          {activeId==="dashboard-financeiro"  && <DashboardFinanceiro/>}
          {activeId==="fechamento-mensal"     && <FechamentosList/>}
          {activeId==="condominios"         && <CondominiosList/>}
          {activeId==="condominos"          && <CondominosList/>}
          {activeId==="unidades"            && <UnidadesList/>}
          {activeId==="funcionarios"        && <FuncionariosList/>}
          {activeId==="fornecedores"        && <FornecedoresList/>}
          {activeId==="contasContabeis"     && <ContasContabeisList/>}
          {activeId==="contasBancarias"     && <ContasBancariasList/>}
          {activeId==="contasPagar"         && <ContasPagarList onNavigate={handleNavigate}/>}
          {activeId==="pagamentos"          && <PagamentosFila/>}
          {activeId==="contasReceber"       && <ContasReceberList/>}
          {activeId==="despesasRecorrentes" && <DespesasRecorrentesList/>}
          {activeId==="areasComuns"         && <AreasComumList/>}
          {activeId==="reservas"            && <ReservasList/>}
          {activeId==="ocorrencias"         && <OcorrenciasList/>}
          {activeId==="comunicados"         && <ComunicadosList/>}
          {activeId==="assembleias"         && <AssembleiasList/>}
          {activeId==="cobrancas"           && <CobrancasList/>}
          {activeId==="boletos"             && <BoletosList/>}
          {activeId==="renegociacoes"       && <RenegociacoesList/>}
          {activeId==="relatorios"          && <RelatoriosList/>}
          {activeId==="saas-dashboard"     && isSuperAdmin && <SaasDashboard onNavigate={handleNavigate}/>}
          {activeId==="portaria-dashboard"  && <PortariaDashboard/>}
          {activeId==="saas-clientes"      && isSuperAdmin && <ClientesList/>}
          {activeId==="saas-planos"        && isSuperAdmin && <PlanosList/>}
          {activeId==="rel-dre"           && <RelatoriosList abaInicial="dre"           mostrarTabs={false}/>}
          {activeId==="rel-balancete"     && <RelatoriosList abaInicial="balancete"     mostrarTabs={false}/>}
          {activeId==="rel-inadimplencia"      && <RelatoriosList abaInicial="inadimplencia" mostrarTabs={false}/>}
          {activeId==="rel-extrato-analitico" && <RelatoriosList abaInicial="extrato-analitico" mostrarTabs={false}/>}
          {activeId==="rel-extrato"           && <RelatoriosList abaInicial="extrato"           mostrarTabs={false}/>}
          {activeId==="rel-prestacao"         && <RelatoriosList abaInicial="prestacao"         mostrarTabs={false}/>}
          {activeId==="cadastro-jobs"       && <CadastroJobs/>}
          {activeId==="audit"               && <AuditLogs/>}
          {activeId==="retorno-cnab"        && <RetornoCNAB/>}
          {activeId==="controlid"           && <ControlIdView/>}
          {activeId==="rel-demonstrativo"       && <RelatoriosList abaInicial="demonstrativo"       mostrarTabs={false}/>}
          {activeId==="rel-consumo"           && <RelatoriosList abaInicial="consumo"           mostrarTabs={false}/>}
          {activeId==="usuarios"            && isAdmin && <UsuariosList/>}
          {activeId==="consumo"            && <ConsumoList/>}
          {activeId==="estoque"            && <EstoqueView onNavigate={handleNavigate}/>}
          {activeId==="pedidos"            && <PedidosList onNavigate={handleNavigate}/>}
          {activeId==="compras"            && <ComprasView onNavigate={handleNavigate}/>}
          {activeId==="cotacao"            && <CotacaoList onNavigate={handleNavigate}/>}
          {activeId==="inventario"         && <InventarioView onNavigate={handleNavigate}/>}
          {activeId==="checklists"         && <ChecklistsView/>}
          {activeId==="whatsapp"           && <WhatsappConfig/>}
          {activeId==="prestacao"           && <PrestacaoContasList/>}
          {activeId==="config"              && <ConfiguracoesList/>}
          {!KNOWN.includes(activeId)        && <EmBreve label="Módulo em desenvolvimento" icon="bi-tools"/>}
        </main>
      </div>
    </div>
  );
}

export default function App() {
  // Rota pública: /boleto/:token — sem autenticação
  if (window.location.pathname.startsWith("/boleto/")) {
    return (
      <ThemeProvider>
        <BoletoPublico />
      </ThemeProvider>
    );
  }
  if (window.location.pathname.startsWith("/cotacao-fornecedor")) {
    return (
      <ThemeProvider>
        <CotacaoFornecedorPublic />
      </ThemeProvider>
    );
  }
  // Rota pública: /reset-senha?token=... — sem autenticação
  if (window.location.pathname.startsWith("/reset-senha")) {
    return (
      <ThemeProvider>
        <ResetSenhaPage />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppInner/>
      </AuthProvider>
    </ThemeProvider>
  );
}
